import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import '../../services/GlobalVariables'
import axios from 'axios'

const API_URL = global.SET_API_URL + 'itemCompany/'

const initialState = {
    itemCompanyies: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: ""
}

export const addNewItemCompany = createAsyncThunk('itmcmp/anic', async (itmCmpData, thunkAPI) => {
    try {
        await axios.post(API_URL + 'addNewItemCompany', itmCmpData)
        return itmCmpData
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getAllItemCompanies = createAsyncThunk('itmcmp/gaic', async (_, thunkAPI) => {
    try {
        const result = await axios.get(API_URL + 'getAllItemCompanies')
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const deleteItemCompany = createAsyncThunk('itmcmp/dic', async (itmCmpCode, thunkAPI) => {
    try {
        console.log(itmCmpCode)
        const result = await axios.post(API_URL + 'deleteItemCompany', itmCmpCode)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const itemCompanySlice = createSlice({
    name: 'menus',
    initialState,
    reducers: {
        reset: (state) => {
            state.heads = []
            state.isLoading = false
            state.isError = false
            state.isSuccess = false
            state.message = ""
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(addNewItemCompany.pending, (state) => {
                state.isLoading = true
            })
            .addCase(addNewItemCompany.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.itemCompanyies.push(action.payload)
            })
            .addCase(addNewItemCompany.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(getAllItemCompanies.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getAllItemCompanies.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.itemCompanyies = action.payload
            })
            .addCase(getAllItemCompanies.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
    }
})

export const { reset } = itemCompanySlice.actions

export default itemCompanySlice.reducer